export function maskEmail(email = ''): string {
  const [username, domain] = email.split('@');
  const maskedUsername = [...username.split('')]
    .map((v, i) => (i < 2 ? v : '*'))
    .join('');
  return `${maskedUsername}@${domain}`;
}

export function maskPhoneNumber(phoneNumber = ''): string {
  const maskedPhone = [...phoneNumber.split('')]
    .map((v, i) => (i < 4 || i > phoneNumber.length - 4 ? v : '*'))
    .join('');
  return maskedPhone;
}
